// LOCAL COMPONENTS
import ComparisonCell from './parts/ComparisonCell';

export const COLUMNS = {
  vinNumber: {
    key: 'vin_num',
    label: 'VIN',
    placeholder: '',
    component: ComparisonCell,
    comparison: {
      comparedToKey: 'audit_vin_num'
    },
    width: 170
  },
  stockNumber: {
    key: 'stock_num',
    label: 'Stock #',
    placeholder: '',
    component: ComparisonCell,
    comparison: {
      comparedToKey: 'audit_stock_num'
    },
    width: 110
  },
  dealNumber: {
    key: 'deal_number',
    label: 'Deal #',
    placeholder: '',
    component: ComparisonCell,
    comparison: {
      comparedToKey: 'audit_deal_number'
    },
    width: 90
  }
};

export const FE_ROLLUP_COLUMNS = [
  [
    {
      label: 'FE Gross BP'
    },
    {
      key: 'rollup_total.fe_gross_bp'
    },
    {
      key: 'rollup_average.fe_gross_bp'
    }
  ],
  [
    {
      label: 'Dealer Pack'
    },
    {
      key: 'rollup_total.dealer_pack'
    },
    {
      key: 'rollup_average.dealer_pack'
    }
  ],
  [
    {
      label: 'FE Gross AP'
    },
    {
      key: 'rollup_total.frontend_gross_ap'
    },
    {
      key: 'rollup_average.frontend_gross_ap'
    }
  ]
];

export const FE_TOTAL_COLUMNS_MATCHES = [
  [
    {
      label: 'Matching FE Gross'
    },
    {
      key: 'rollup_total.frontend_gross_ap'
    },
    {
      key: 'rollup_average.frontend_gross_ap'
    }
  ]
];

export const FE_TOTAL_COLUMNS_NO_MATCHES = [
  [
    {
      label: 'FE Gross BP'
    },
    {
      key: 'grand_total.fe_gross_bp'
    },
    {
      key: 'grand_average.fe_gross_bp'
    }
  ],
  [
    {
      label: 'DMS FE Gross BP'
    },
    {
      key: 'grand_total.dms_fe_gross_bp'
    },
    {
      key: 'grand_average.dms_fe_gross_bp'
    }
  ],
  [
    {
      label: 'Difference'
    },
    {
      key: 'grand_total.difference'
    },
    {
      key: 'grand_average.difference'
    }
  ]
];

export const BE_ROLLUP_COLUMNS = [
  [
    {
      label: 'Total AM Gross'
    },
    {
      key: 'rollup_total.total_am_gross'
    },
    {
      key: 'rollup_average.total_am_gross'
    }
  ],
  [
    {
      label: 'FM Gross'
    },
    {
      key: 'rollup_total.fm_gross'
    },
    {
      key: 'rollup_average.fm_gross'
    }
  ],
  [
    {
      label: 'BE Gross'
    },
    {
      key: 'rollup_total.backend_gross'
    },
    {
      key: 'rollup_average.backend_gross'
    }
  ]
];

export const BE_TOTAL_COLUMNS_MATCHES = [
  [
    {
      label: 'Matching BE Gross'
    },
    {
      key: 'rollup_total.backend_gross'
    },
    {
      key: 'rollup_average.backend_gross'
    }
  ]
];

export const BE_TOTAL_COLUMNS_NO_MATCHES = [
  [
    {
      label: 'BE Gross'
    },
    {
      key: 'grand_total.backend_gross'
    },
    {
      key: 'grand_average.backend_gross'
    }
  ],
  [
    {
      label: 'DMS BE Gross'
    },
    {
      key: 'grand_total.dms_backend_gross'
    },
    {
      key: 'grand_average.dms_backend_gross'
    }
  ],
  [
    {
      label: 'Difference'
    },
    {
      key: 'grand_total.difference'
    },
    {
      key: 'grand_average.difference'
    }
  ]
];
